// 以下の記法じゃないと翻訳できないので全体をeslint-disableしている
/* eslint-disable global-require */
export const resources = {
  en: {
    translation: {
      authorization: require('../view/locales/authorization/en.yml'),
      comment: require('../view/locales/comment/en.yml'),
      common: require('../view/locales/common/en.yml'),
      contact: require('../view/locales/contact/en.yml'),
      csv_export_job: require('../view/locales/csv_export_job/en.yml'),
      dashboard: require('../view/locales/dashboard/en.yml'),
      dummy: require('../view/locales/dummy/en.yml'),
      export: require('../view/locales/export/en.yml'),
      form: require('../view/locales/form/en.yml'),
      layouts: require('../view/locales/layouts/en.yml'),
      manual: require('../view/locales/manual/en.yml'),
      member: require('../view/locales/member/en.yml'),
      module: require('../view/locales/module/date_changer/en.yml'),
      mypage: require('../view/locales/mypage/en.yml'),
      notice: require('../view/locales/notice/en.yml'),
      parts: require('../view/locales/parts/report/en.yml'),
      search: require('../view/locales/search/en.yml'),
      second_comment: require('../view/locales/second_comment/en.yml'),
      setting: require('../view/locales/setting/en.yml'),
      team: require('../view/locales/team/en.yml'),
      model: require('../view/locales/model.en.yml'),
      time: require('../view/locales/time.en.yml'),
      validate: require('../view/locales/validate/en.yml'),
      timeline_list: require('../view/locales/timeline_list/en.yml'),
      occupation: require('../view/locales/occupation/en.yml'),
      monthly_comment: require('../view/locales/monthly_comment/en.yml'),
      monthly_second_comment: require('../view/locales/monthly_second_comment/en.yml'),
      login: require('../view/locales/login/en.yml'),
      company_csv_import: require('../view/locales/company_csv_import/en.yml'),
      client: require('../view/locales/client/en.yml'),
      range: require('../view/locales/range/en.yml'),
      report: require('../view/locales/report/en.yml'),
    },
  },
  ja: {
    translation: {
      authorization: require('../view/locales/authorization/ja.yml'),
      comment: require('../view/locales/comment/ja.yml'),
      common: require('../view/locales/common/ja.yml'),
      contact: require('../view/locales/contact/ja.yml'),
      csv_export_job: require('../view/locales/csv_export_job/ja.yml'),
      dashboard: require('../view/locales/dashboard/ja.yml'),
      dummy: require('../view/locales/dummy/ja.yml'),
      export: require('../view/locales/export/ja.yml'),
      form: require('../view/locales/form/ja.yml'),
      layouts: require('../view/locales/layouts/ja.yml'),
      manual: require('../view/locales/manual/ja.yml'),
      member: require('../view/locales/member/ja.yml'),
      module: require('../view/locales/module/date_changer/ja.yml'),
      mypage: require('../view/locales/mypage/ja.yml'),
      notice: require('../view/locales/notice/ja.yml'),
      parts: require('../view/locales/parts/report/ja.yml'),
      search: require('../view/locales/search/ja.yml'),
      second_comment: require('../view/locales/second_comment/ja.yml'),
      setting: require('../view/locales/setting/ja.yml'),
      team: require('../view/locales/team/ja.yml'),
      model: require('../view/locales/model.ja.yml'),
      time: require('../view/locales/time.ja.yml'),
      validate: require('../view/locales/validate/ja.yml'),
      timeline_list: require('../view/locales/timeline_list/ja.yml'),
      occupation: require('../view/locales/occupation/ja.yml'),
      monthly_comment: require('../view/locales/monthly_comment/ja.yml'),
      monthly_second_comment: require('../view/locales/monthly_second_comment/ja.yml'),
      login: require('../view/locales/login/ja.yml'),
      company_csv_import: require('../view/locales/company_csv_import/ja.yml'),
      client: require('../view/locales/client/ja.yml'),
      range: require('../view/locales/range/ja.yml'),
      report: require('../view/locales/report/ja.yml'),
    },
  },
}

export default resources
